import { useMutation, useQueryClient } from 'react-query';

import { useServiceError } from '@/hooks';
import { vinculateSupplierInQuotation } from './QuotationsSuppliers.service';
import { notification } from 'antd';

export function useQuotationSuppliersSend() {
  const queryClient = useQueryClient();

  const query = useMutation(vinculateSupplierInQuotation, {
    onSuccess(_, data) {
      notification.success({
        message: 'Sucesso',
        description: 'Fornecedor adicionado na cotação!',
      });

      queryClient.invalidateQueries([
        'quotations',
        data.quotationId,
        'suppliers',
      ]);
    },
  });

  useServiceError(query.error);

  return query;
}
